export const requiredRemoveHeader = [
    "CPF",
    "NOME",
    "PROCESSOS",
]